// API helper for collection categories operations
import { API_BASE_URL as BASE_URL, getUserDepartment } from "./base";
import { apiJson, apiFetch } from './apiFetch';
import { withCsrfHeaders, fetchWithCsrfRetry } from "./csrf"; // kept temporarily for existing create/update/delete logic

// Helper function to get user department and create headers
const getApiHeaders = () => {
  const userDepartment = getUserDepartment();

  return {
    "Content-Type": "application/json",
    "X-User-Department": userDepartment,
  };
};

// Get all categories with pagination
export const apiGetAllCategories = async (page = 1, limit = 10) => {
  try {
    return await apiJson(`${BASE_URL}/categories?page=${page}&limit=${limit}`);
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

// Search categories
export const apiSearchCategories = async (searchParams, page = 1, limit = 10) => {
  try {
    const queryParams = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (searchParams.kategori_kutipan)
      queryParams.append("kategori_kutipan", searchParams.kategori_kutipan);
    if (searchParams.kod_kategori) queryParams.append("kod_kategori", searchParams.kod_kategori);
    return await apiJson(`${BASE_URL}/categories/search?${queryParams.toString()}`);
  } catch (error) {
    console.error("Error searching categories:", error);
    throw error;
  }
};

// Create new category
export const apiCreateCategory = async (categoryData) => {
  try {
    const response = await apiFetch(`${BASE_URL}/categories`, {
      method: "POST",
      body: JSON.stringify(categoryData),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};

// Update category
export const apiUpdateCategory = async (id, categoryData) => {
  try {
    const response = await apiFetch(`${BASE_URL}/categories/${id}`, {
      method: "PUT",
      body: JSON.stringify(categoryData),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Error updating category:", error);
    throw error;
  }
};

// Delete category
export const apiDeleteCategory = async (id) => {
  try {
    const response = await apiFetch(`${BASE_URL}/categories/${id}`, { method: "DELETE" });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Error deleting category:", error);
    throw error;
  }
};
